module.exports = __webpack_public_path__ + "static/img/result_main_banner.cba5ec7c.png";